import { ingestAPIObject } from "../utils/api";
export class SeasonDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
}
export class SaveSeasonDTO {
}
